module.exports = __webpack_public_path__ + "static/media/app-formas-pagamento.4a1ec948.png";